export default "__VITE_ASSET__BUbGVhnz__"